import { render, staticRenderFns } from "./CreatePartTimePercentageRecordComponent.vue?vue&type=template&id=23a9adc3&scoped=true"
import script from "./CreatePartTimePercentageRecordComponent.vue?vue&type=script&lang=js"
export * from "./CreatePartTimePercentageRecordComponent.vue?vue&type=script&lang=js"
import style0 from "./CreatePartTimePercentageRecordComponent.vue?vue&type=style&index=0&id=23a9adc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a9adc3",
  null
  
)

export default component.exports